import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from "./app.config.service";

import { Observable, catchError, of } from "rxjs";

import { Store } from "@ngrx/store";
import { CanvasData } from "../components/whiteboard/whiteboard.component";
import { AddGuest } from "../models/WebServer/addGuest";
import { Partecipant } from "../models/WebServer/partecipant";
import { PartecipantInfo } from "../models/WebServer/partecipantInfo";
import { PartecipantParameters } from "../models/WebServer/partecipantStatus";
import { RemoveGuest } from "../models/WebServer/removeGuest";
import { Session } from "../models/WebServer/session";
import { BaseHttp } from "./base.http";


@Injectable()
export class SessionService extends BaseHttp {
  // private getSessSub: Subject<any> = new Subject<any>();
  // private endSessSub: Subject<any> = new Subject<any>();
  // private extendSessSub: Subject<any> = new Subject<any>();

  constructor(http: HttpClient, config: AppConfigService, store: Store) {
    super(http, store, config);
  }




  // getGetSessSubscription(): Subject<any> {
  //   return this.getSessSub;
  // }

  // getEndSessSubscription(): Subject<any> {
  //   return this.endSessSub;
  // }

  // getExtendSessSubscription(): Subject<any> {
  //   return this.extendSessSub;
  // }

  // getByPartecipantId(partecipantId: string): Observable<Session> {
  //   return this.http.get<Session>(`${this.config.apiBaseUrl}/partecipant/${partecipantId}`);
  // }

  getSession(partecipantId: string): Observable<Session> {
    return this.getRequest<Session>(`${this.config.apiBaseUrl}/session/partecipant/${partecipantId}`);
  }

  getPartecipant(partecipantId: string): Observable<PartecipantInfo> {
    return this.getRequest<PartecipantInfo>(`${this.config.apiBaseUrl}/partecipant/${partecipantId}`);
  }
  updatePartecipantParameters(partecipantId: string, parameters: PartecipantParameters): Observable<Partecipant> {
    return this.putRequest<Partecipant>(`${this.config.apiBaseUrl}/partecipant/update/${partecipantId}`, parameters);
  }

  addGuest(phoneNumber: string, email: string, alias: string, viewPreviousChat: boolean, superUser: boolean): Observable<Session> {
    const req: AddGuest = {
      alias,
      phoneNumber,
      email,
      primaryPartecipantId: this.config.partecipantId,
      viewPreviousChat,
      super: superUser
    }
    const sessionId: string = this.config.sessionId || '';
    //TODO: riaggiungere questo check header? lo si fa solo per l'extend-session (non per il terminate)
    // var headers_object = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Basic " + basicToken // calcolato come part[0].id-part[1].id
    // });

    // const httpOptions = {
    //   headers: headers_object
    // };
    return this.putRequest<Session>(`${this.config.apiBaseUrl}/session/addGuest/${sessionId}`, req, true);
  }

  removeGuest(guestId: string): Observable<Session> {
    const req: RemoveGuest = {
      primaryPartecipantId: this.config.partecipantId,
      guestPartecipantId: guestId
    }
    const sessionId: string = this.config.sessionId || '';
    //TODO: riaggiungere questo check header? lo si fa solo per l'extend-session (non per il terminate)
    // var headers_object = new HttpHeaders({
    //   'Content-Type': 'application/json',
    //   'Authorization': "Basic " + basicToken // calcolato come part[0].id-part[1].id
    // });

    // const httpOptions = {
    //   headers: headers_object
    // };
    return this.postRequest<Session>(`${this.config.apiBaseUrl}/session/removeGuest/${sessionId}`, req, true);
  }

  // private getRequest<T>(url: string): Observable<T> {
  //   return this.http.get<T>(url).pipe(
  //     map((response: T) => response)
  //     //, catchError(err => {
  //     //   console.log(err);
  //     //   return of<T>(err);
  //     // })
  //   );
  // }


  // endSession(sessionId: string, basicToken: string): void {
  //   var headers_object = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'Authorization': "Basic " + basicToken
  //   });

  //   const httpOptions = {
  //     headers: headers_object
  //   };
  //   this.http.put<Session>(`${this.config.getSessionEndPoint()}/endsession/${sessionId}`, null, httpOptions).toPromise().then((e) => {
  //     this.endSessSub.next(e);
  //   }, err => {
  //     console.error(err);
  //     this.endSessSub.next(err);
  //   });
  // }

  // extendSession(sessionId: string, minutes: number, basicToken: string): void {
  //   // // var headers_object = new HttpHeaders({
  //   // //   'Content-Type': 'application/json',
  //   // //   'Authorization': "Basic " + basicToken
  //   // // });
  //   // var headers_object = new HttpHeaders({
  //   //   'Content-Type': 'application/json',
  //   //   'ext-auth': basicToken
  //   // });
  //   // const httpOptions = {
  //   //   headers: headers_object
  //   // };
  //   // this.putRequest<Session>(`${this.config.apiBaseUrl}/session/extendsession/${sessionId}/${minutes}`, null, httpOptions).toPromise().then((e) => {
  //   //   this.extendSessSub.next(e);
  //   // }, err => {
  //   //   console.error(err);
  //   //   this.extendSessSub.next(err);
  //   // });
  // }

  addWhiteboardImage(sessionId: string, image: CanvasData): Observable<boolean> 
  {
    return this.postRequest<boolean>(`${this.config.apiBaseUrl}/session/AddWhiteboardImage/${sessionId}`, image, true);
  }

  getWhiteboardImage(sessionId: string): Observable<CanvasData> 
  {
    return this.getRequest<CanvasData>(`${this.config.apiBaseUrl}/session/GetWhiteboardImage/${sessionId}`, true);
  }

  getSupportedFileExtensions(): Observable<string[]> {
    return this.getRequest<string[]>(`${this.config.apiBaseUrl}/session/supportedFileExtensions/${this.config.partecipantId}`, true).pipe(
      catchError(err => {
        console.error('Error fetching supported file extensions:', err);
        return of(['*']);
      })
    );
  }
}
